import { TIER_ORDER } from '../consts';
import { USE_TOP_PERFORMER_MOCK } from '../mockData';
import { DisplayTier, PerformerStatus } from '../types';
import {
  GoalState,
  PerformanceTier,
  PerformerStatusEligible,
  PerformerStatusIneligible,
  PerformerStatusNotEvaluated,
  PerformerStatusType,
  TargetingValues,
} from '@provider-portal/common/api/openapi_gen/deliveryProviderPortal/deliveryProviderPortal/models';

export { getMonthName } from './getMonthName';

/** A status for a merchant that was evaluated, i.e. holding one of the performance tiers. */
export function isEligible(status: PerformerStatus): status is PerformerStatusEligible {
  return status.type === PerformerStatusType.ELIGIBLE;
}

/** A status for a merchant that was NOT evaluated. */
export function isIneligible(status: PerformerStatus): status is PerformerStatusIneligible {
  return status.type === PerformerStatusType.INELIGIBLE;
}

/** A status for a merchant that was NOT evaluated. */
export function isNotEvaluated(status: PerformerStatus): status is PerformerStatusNotEvaluated {
  return status.type === PerformerStatusType.NOT_EVALUATED;
}

export function getDisplayTier(status: PerformerStatus): DisplayTier {
  return isEligible(status) ? status.tier : 'ineligible';
}

export function countCompletedGoals(status: PerformerStatus): number {
  if (!isEligible(status)) {
    return 0;
  }

  return status.goal_statuses.filter((goal) => goal.state === GoalState.COMPLETED).length;
}

/** The tier directly above `tier` if one exists. The same tier when it is already the highest. undefined if uneligible. */
export function getNextTier(tier: DisplayTier): PerformanceTier | undefined {
  const currentTierIndex = TIER_ORDER.findIndex((orderedTier) => orderedTier === tier);
  if (currentTierIndex < 0) {
    return undefined;
  }
  if (currentTierIndex === TIER_ORDER.length - 1) {
    return TIER_ORDER[currentTierIndex];
  }
  return TIER_ORDER[currentTierIndex + 1];
}

/** Mocked data bypasses the targeting flag, so the screens are reachable without it. */
export function isTopPerformerEnabled(targetingParameters: TargetingValues) {
  return (
    USE_TOP_PERFORMER_MOCK ||
    Boolean(targetingParameters.delivery_provider_portal_flags.show_top_performer_content)
  );
}
